<template class="">
  <div class="flex flex-1 flex-col gap-y-2 overflow-visible">
    <div class="flex min-h-0 flex-1 flex-col-reverse overflow-y-auto pr-3">
      <div class="flex flex-col-reverse gap-2">
        <CommentBubble
          v-for="(comment, index) in comments"
          :key="index"
          :comment="comment"
          @comment-deletion="handleDeleteComment"
          @comment-reaction="handleCommentReaction"
          @comment-reply="handleCommentReply"
        />
      </div>
    </div>
  </div>
  <div class="z-10 mt-2 flex flex-shrink-0 flex-row items-end gap-2">
    <div class="flex flex-1 flex-shrink-0 justify-end">
      <div class="relative w-full">
        <div
          class="overflow-hidden rounded-lg border border-gray-300 shadow-sm dark:border-slate-700 dark:bg-slate-500"
        >
          <label for="comment" class="sr-only">{{
            $t('global.add_remark')
          }}</label>
          <textarea
            id="comment"
            v-model="internalText"
            rows="2"
            name="comment"
            class="block w-full resize-none border-0 py-3 focus:ring-0 dark:text-slate-500 sm:text-sm"
            :placeholder="$t('attributes.add_comment')"
          />

          <!-- Spacer element to match the height of the toolbar -->
          <div class="pb-2" aria-hidden="true">
            <div class="py-px">
              <div class="h-7" />
            </div>
          </div>
        </div>

        <div
          class="absolute inset-x-0 bottom-0 flex justify-end py-2 pl-3 pr-2"
        >
          <div class="flex-shrink-0">
            <BaseButton
              :title="$t('button.send')"
              icon="paper-plane"
              size="extra-small"
              @click="handleSendMessage"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <AvatarComponent :user_id="auth.id" />
    </div>
  </div>
</template>

<script>
import AvatarComponent from '@c/AvatarComponent'
import CommentBubble from '@c/CommentBubble'
import { mapActions, mapGetters } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'CommentBox',
  components: { BaseButton, CommentBubble, AvatarComponent },
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    submitFunction: {
      type: Function,
      required: true
    },
    commentDeletionSuccessCallback: {
      type: Function,
      required: true
    },
    commentReactionSuccessCallback: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      internalText: null
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth'
    })
  },
  methods: {
    ...mapActions({
      processDeleteCommentAction: 'comments/deleteComment',
      processAddReactionToTaskDossierAction:
        'comments/addReactionToTaskDossier',
      processReplyToACommentAction: 'comments/replyToAComment'
    }),
    handleSendMessage() {
      this.submitFunction(this.internalText)
      this.internalText = null
    },
    handleDeleteComment(comment_id) {
      this.processDeleteCommentAction({
        comment_id: comment_id,
        successCallback: () => {
          this.$h.toastify(this.$t('toasts.comment_deleted'), {
            className: 'toastify-content success'
          })
          this.commentDeletionSuccessCallback()
        }
      })
    },
    handleCommentReaction(payload) {
      this.processAddReactionToTaskDossierAction({
        comment_id: payload.comment_id,
        reaction: payload.reaction,
        successCallback: () => {
          this.$h.toastify(this.$t('toasts.reaction_added_to_comment'), {
            className: 'toastify-content success'
          })
          this.commentReactionSuccessCallback()
        }
      })
    },
    handleCommentReply(payload) {
      this.processReplyToACommentAction({
        comment_id: payload.comment_id,
        text: payload.text,
        successCallback: () => {
          this.$h.toastify(this.$t('toasts.comment_reply_added'), {
            className: 'toastify-content success'
          })
        }
      })
    }
  }
}
</script>
